/**
 * Imported first by main.tsx, before the router reads the address: an e-mail link's
 * single-use hash in the query, or a Supabase session in the fragment (./fragmenSesi), leaves
 * the address bar and this history entry at once, so neither the router nor a later chunk ever
 * holds it there; what a page needs is kept in memory for it, any other session is revoked at
 * GoTrue. Release 26: not on a page leaving for the new address (./pindahAwal), whose link
 * opens there with its query and fragment.
 */
import { cabutSesiTautan } from '../auth/supabase'
import { tanganiFragmenSesi } from './fragmenSesi'
import { SEDANG_PINDAH } from './pindahAwal'

// Release 26: a page leaving for the new address takes the link with it, untouched.
if (!SEDANG_PINDAH) {
  tanganiFragmenSesi(
    window.location,
    (alamat) => window.history.replaceState(window.history.state, '', alamat),
    cabutSesiTautan,
  )
}
